// Convenience composable to safely access the injected $apiFetch instance.
// Usage: const apiFetch = useApiFetch(); await apiFetch('/api/getProduct', { method: 'POST', body: {...} });
export const useApiFetch = () => {

  const nuxtApp = useNuxtApp();

  // Provide a helpful error if plugin hasn't run yet (e.g., imported too early)
  if (!('$apiFetch' in nuxtApp)) {

    throw new Error('`$apiFetch` is not available yet. Ensure you call useApiFetch() inside setup() / a composable after plugins load.');
  
  }

  return nuxtApp.$apiFetch as typeof $fetch;

};
